import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      toast.error("Enter a valid email address.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/newsletter`, { email: trimmed });
      setSuccess(true);
      setEmail("");
      toast.success("You're on the list. Welcome to Sourcing Signals.");
    } catch (err) {
      console.error(err);
      toast.error("Couldn't subscribe right now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="newsletter-signup" className="max-w-md">
      <div className="text-xs font-semibold tracking-[0.24em] uppercase text-brand-olive">
        Sourcing Signals
      </div>
      <h3 className="font-display mt-4 text-2xl text-brand-deep font-light leading-snug">
        Brief market intelligence, delivered occasionally.
      </h3>
      <p className="mt-3 text-sm text-brand-muted leading-relaxed font-light">
        Short, infrequent notes from FFIB analysts on specialty ingredient
        markets. No spam, no promotions — unsubscribe anytime.
      </p>

      {success ? (
        <div
          data-testid="newsletter-success"
          className="mt-6 flex items-center gap-2 text-sm text-brand-olive"
        >
          <CheckCircle2 className="w-4 h-4" strokeWidth={1.6} />
          You're subscribed. Welcome.
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="mt-6 flex flex-col sm:flex-row gap-2"
          data-testid="newsletter-form"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            aria-label="Email address"
            data-testid="newsletter-email-input"
            className="flex-1 bg-brand-ivory border border-brand-border text-brand-deep px-4 py-3 text-sm focus:outline-none focus:border-brand-olive focus:ring-1 focus:ring-brand-olive transition-colors placeholder:text-brand-quiet/70 font-light"
          />
          <button
            type="submit"
            disabled={submitting}
            data-testid="newsletter-submit-button"
            className="inline-flex items-center justify-center gap-2 bg-brand-olive hover:bg-brand-hover text-brand-cream px-5 py-3 text-sm font-medium transition-colors disabled:opacity-50"
          >
            {submitting ? "..." : (
              <>
                Subscribe
                <ArrowRight className="w-4 h-4" />
              </>
            )}
          </button>
        </form>
      )}
    </div>
  );
}
